import React, { useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom';
import CustomNavbar from './pages/user-managemnet/PublicNavbar';
import PrivateNavbar from './pages/user-managemnet/Navbar';
import Sidebar from './pages/user-managemnet/Sidebar';
import Footer from './pages/user-managemnet/Footer';
import Swal from 'sweetalert2';

const useAuth = () => {
    let user = localStorage.getItem('token');
    // console.log(user)
    if (user) {
        try {
            if ((user)) {
                return user;
            }
        } catch (error) {
            return false
        }

    } else {
        return false
    }
}

const ProtectedRoutes = (props) => {
    const auth = useAuth()
    const navigate = useNavigate()
    const location = useLocation()
    const [sidebarShow, setSidebarShow] = useState(false);
    var permission = JSON.parse(localStorage.getItem('actions'))

    const isRouteAuthorized = () => {
        if (location.pathname.includes('profile-analytics-list') || location.pathname.includes('video-analytics') || location.pathname.includes('button-analytics')) {
            return localStorage.getItem('biolink_status') === 'paid';
        }
        return true;
    };


    if (!auth) {
        return <Navigate to="/login" />
    }
    else if (!isRouteAuthorized()) {
        Swal.fire({
            title: 'Access Denied',
            text: "Biolink Subscription Required",
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result.isConfirmed) {
                navigate(-1)
            }
        })
        return null;
    }
    else {
        return (
            <div>
                {/* {location?.pathname.slice(0, 11) == '/superadmin' ? <SuperAdminNavbar /> : <AdminNavbar />} */}
                <PrivateNavbar onMenuClick={() => setSidebarShow(true)} />

                <div className="main-content mt-3 ps-3 pe-3">
                    <div className='d-flex'>
                        <div className='sidebar_section'>
                            <Sidebar show={sidebarShow} handleClose={() => setSidebarShow(false)} />
                        </div>
                        <div className='main_layout' style={{ marginBottom: '150px' }}>
                            <Outlet />

                        </div>
                    </div>

                </div>
                <div className='fixed-bottom'>
                    <Footer />
                </div>
            </div>
        )
    }
}

export default ProtectedRoutes;
